import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import store from 'dashboard/store';
import { isCommercialFeatureEnabled } from 'dashboard/helper/commercialFeatureHelper';

const meta = {
  permissions: ['administrator'],
  featureFlag: FEATURE_FLAGS.BOTZ_CRM_CATALOG,
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/commercial/catalog'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'commercial_catalog_settings',
          component: Index,
          meta,
          beforeEnter: to =>
            isCommercialFeatureEnabled({
              accountId: to.params.accountId,
              feature: FEATURE_FLAGS.BOTZ_CRM_CATALOG,
              isFeatureEnabled:
                store.getters['accounts/isFeatureEnabledonAccount'],
            }) || frontendURL(`accounts/${to.params.accountId}/dashboard`),
        },
      ],
    },
  ],
};
